import { render, staticRenderFns } from "./ConfigurationForm.vue?vue&type=template&id=0c31e81a&scoped=true&"
import script from "./ConfigurationForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm.vue?vue&type=style&index=0&id=0c31e81a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31e81a",
  null
  
)

export default component.exports